import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';

interface ItemData {
  name: string;
  age: string;
  address: string;
}


@Component({
  selector: 'app-message-temp',
  templateUrl: './message-temp.component.html',
  styleUrls: ['./message-temp.component.scss'],
})
export class MessageTemplateComponent implements OnInit {
  listOfData: ItemData[] = [];
  value?: string;
  // demoValue?: number;
  name = new FormControl('');
  demoValue = 3;
  checked = true;
  visible: boolean;
  isEdit: boolean;

  constructor() {
    
   }
  ngOnInit() {
    for (let i = 0; i < 100; i++) {
      this.listOfData.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }


  // open(): void {
  //   this.visible = true;
  // }
  // close(): void {
  //   this.isEdit = false;
  //   this.visible = false;
  // }

  open(): void {
    this.visible = true;
  }

  close(): void {
    this.isEdit = false;
    this.visible = false;
  }

}
